<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">ปฏิทินกิจกรรม</div>
      </div>
      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="keyword = $event"
              @onEnter="getDataSearch()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <v-toolbar flat class="transparent">
      <v-btn
        small
        depressed
        fab
        color="#fff"
        width="24"
        height="24"
        style="background-color: #f65f3c"
        @click="prev"
      >
        <v-icon small class="white--text"> mdi-chevron-left </v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar" class="px-5">
        {{ formatTitle() }}
      </v-toolbar-title>
      <v-btn
        small
        depressed
        fab
        color="#fff"
        width="24"
        height="24"
        style="background-color: #f65f3c"
        @click="next"
      >
        <v-icon small class="white--text"> mdi-chevron-right </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <Button @onClick="createCalendarActivity">+ เพิ่มกิจกรรม</Button>
    </v-toolbar>

    <div class="d-flex justify-end my-4">
      <!-- legend -->
      <div class="d-flex align-center gap-16">
        <div
          v-for="eventType in eventTypeConstant"
          :key="eventType.value"
          class="d-flex align-center gap-8"
        >
          <div
            class="region-dot"
            :style="{ backgroundColor: eventType.color, border: `1.5px solid ${eventType.borderColor || eventType.color}` }"
          ></div>
          <span class="region-text">{{ eventType.text }}</span>
        </div>
      </div>
    </div>

    <divcard class="mt-5">
      <v-container>
        <!-- ปฏิทิน -->

        <v-sheet min-height="600">
          <v-calendar
            class="custom-calendar"
            v-model="selectedDate"
            ref="calendar"
            :events="events"
            :event-name="getEventName"
            :event-color="getEventColor"
            :event-text-color="getEventTextColor"
            :event-height="60"
            :day-class="getDayClass"
            event-overlap-mode="stack"
            @click:event="showEventDetails"
          >
            <template #event="{ event, on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="event-card d-flex align-center pa-2"
                :style="{
                  height: '100%',
                  width: '100%',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  gap: '4px',
                  border: `1px solid ${getEventBorderColor(event)}`,
                  borderRadius: '6px',
                  '--event-hover-color': getEventHoverColor(event),
                  '--event-hover-text-color': getEventHoverTextColor(event),
                }"
              >
                <!-- Title + Time -->
                <div style="flex: 1; min-width: 0; overflow: hidden">
                  <div class="event-name-text">{{ event.name }}</div>
                  <div class="event-time-text">
                    {{ event.startTime || ""
                    }}{{ event.startTime && event.endTime ? " - " : ""
                    }}{{ event.endTime || "" }}
                  </div>
                  <!-- Avatars -->
                  <div v-if="event.participants && event.participants.length" class="d-flex align-center" style="flex-shrink: 0">
                    <div
                      v-for="(p, i) in (event.participants || []).slice(0, 3)"
                      :key="i"
                      class="event-avatar"
                      :style="{
                        marginLeft: i > 0 ? '-6px' : '0',
                        zIndex: 0 + i,
                        backgroundColor: getEventTextColor(event),
                        color: getEventColor(event),
                      }"
                    >
                      {{ (p || "").charAt(0).toUpperCase() }}
                    </div>
                    <div
                      v-if="event.participants && event.participants.length > 3"
                      style="margin-left: 6px; z-index: 0; font-size: 9px"
                    >
                      +{{ event.participants.length - 3 }}
                    </div>
                  </div>
                </div>

                <!-- Quick Action -->
                <v-menu offset-y bottom left>
                  <template #activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-btn
                      x-small
                      icon
                      v-bind="menuAttrs"
                      v-on="menuOn"
                      @click.stop
                      :style="{
                        flexShrink: 0,
                        width: '20px',
                        height: '20px',
                        backgroundColor: getQuickActionBgColor(event),
                        borderRadius: '3px',
                      }"
                    >
                      <v-icon
                        size="16"
                        :style="{ color: getQuickActionColor(event) }"
                      >
                        mdi-dots-horizontal
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense style="min-width: 120px;">
                    <v-list-item
                      @click.stop="quickEdit(event)"
                      style="cursor: pointer"
                    >
                      <v-list-item-title class="d-flex align-center">
                        <Icon
                          icon="fe-edit"
                          style="font-size: 16px"
                          class="mr-1"
                        />
                        แก้ไข</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item
                      @click.stop="quickDelete(event)"
                      style="cursor: pointer"
                    >
                      <v-list-item-title
                        class="d-flex align-center"
                        style="color: #f7491d"
                      >
                        <Icon
                          icon="tabler:trash-x-filled"
                          style="color: #f7491d; font-size: 20px"
                        />
                        ลบ</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-calendar>
        </v-sheet>

        <!-- Modal สำหรับแสดงรายละเอียดกิจกรรม -->
        <v-dialog v-model="dialog" max-width="700px">
          <v-card
            style="display: flex; flex-direction: column; max-height: 85vh"
          >
            <!-- Header -->
            <div class="pa-6 pb-4" style="flex-shrink: 0">
              <div class="d-flex align-center justify-space-between gap-3">
                <div>
                  <div>
                    <Iconify
                      icon="mdi:calendar-text"
                      color="var(--theme-color-one)"
                      style="font-size: 22px; flex-shrink: 0"
                    ></Iconify>
                    <span class="ml-1 font-24 font-w-700 theme-color-one">
                      {{ selectedEvent.name || "ไม่มีข้อมูลกิจกรรม" }}
                    </span>
                  </div>
                  <div class="font-14 grey--text mt-1">รายละเอียดกิจกรรม</div>
                </div>
                <div class="d-flex align-center gap-8">
                  <v-btn
                    v-if="canEditEvent(selectedEvent)"
                    small
                    depressed
                    @click="editCalendarActivity"
                    style="
                      background-color: var(--theme-color-seven);
                      color: white;
                      border-radius: 20px;
                    "
                  >
                    <Icon
                      icon="fe-edit"
                      style="font-size: 16px; color: white"
                      class="mr-1"
                    />
                    แก้ไขกิจกรรม
                  </v-btn>
                  <v-btn
                    v-if="canEditEvent(selectedEvent)"
                    small
                    icon
                    @click="onDelete"
                  >
                    <Icon
                      icon="tabler:trash-x-filled"
                      style="color: #f7491d; font-size: 20px"
                    />
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- Body -->
            <div
              class="pa-4"
              style="
                background-color: #efefef;
                flex: 1;
                display: flex;
                flex-direction: column;
                min-height: 0;
              "
            >
              <!-- Section 1: ช่วงเวลา -->
              <div
                class="pa-4 mb-3"
                style="
                  background-color: var(--theme-color-seven);
                  border-radius: 16px;
                  flex-shrink: 0;
                "
              >
                <div class="d-flex align-center mb-3">
                  <v-icon class="mr-2 white--text">mdi-clock-outline</v-icon>
                  <div class="font-16 font-w-700 white--text">ช่วงเวลา</div>
                </div>
                <div class="d-flex flex-column gap-8">
                  <div class="d-flex align-center gap-8">
                    <div class="font-14 white--text">วันที่</div>
                    <span class="white--text font-20 font-w-700">
                      {{ formatDateShort(selectedEvent.start) }} -
                      {{ formatDateShort(selectedEvent.end) }}
                    </span>
                  </div>
                  <div class="d-flex align-center gap-8">
                    <div class="font-14 white--text">เวลา</div>
                    <span class="white--text font-20 font-w-700">
                      {{ selectedEvent.startTime || "-" }} -
                      {{ selectedEvent.endTime || "-" }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Section 2: รายละเอียดกิจกรรม -->
              <div
                class="pa-4"
                style="
                  background-color: white;
                  border-radius: 16px;
                  overflow-y: auto;
                  flex: 1;
                "
              >
                <div class="d-flex align-center mb-4">
                  <v-icon class="mr-2 theme-color-one"
                    >mdi-calendar-text</v-icon
                  >
                  <div class="font-16 font-w-700 theme-color-one">
                    รายละเอียดกิจกรรม
                  </div>
                </div>
                <div class="d-flex flex-column gap-12">
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      ผู้จัดกิจกรรม
                    </div>
                    <div class="font-16" style="color: #717579">
                      {{ selectedEvent.organizer || "-" }}
                    </div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      ประธานกิจกรรม
                    </div>
                    <div class="font-16" style="color: #717579">
                      {{ selectedEvent.event_leader || "-" }}
                    </div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      ผู้เข้าร่วม
                    </div>
                    <template
                      v-if="
                        selectedEvent.participants &&
                        selectedEvent.participants.length
                      "
                    >
                      <div
                        v-for="(p, idx) in selectedEvent.participants"
                        :key="idx"
                        class="font-16"
                        style="color: #717579"
                      >
                        {{ idx + 1 }}. {{ p }}
                      </div>
                    </template>
                    <div v-else class="font-14" style="color: #717579">-</div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      แนบลิงค์
                    </div>
                    <div class="d-flex align-center gap-8">
                      <div
                        v-if="selectedEvent.location_link"
                        class="d-flex align-center gap-4 cursor-pointer"
                        style="
                          background-color: #ece3da;
                          border-radius: 40px;
                          padding: 4px 10px;
                        "
                        @click="copyToClipboard(selectedEvent.location_link)"
                      >
                        <Iconify
                          icon="bx:link"
                          style="font-size: 15px"
                        ></Iconify>
                        <span class="font-12">คัดลอก</span>
                      </div>
                      <div class="font-16" style="color: #717579">
                        {{ selectedEvent.location_link || "-" }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      เบอร์โทร ผู้ประสานงาน
                    </div>
                    <div class="d-flex align-center gap-8">
                      <div
                        v-if="selectedEvent.coordinator_phone"
                        class="font-12 font-w-700"
                        style="
                          background-color: #ece3da;
                          border-radius: 40px;
                          padding: 4px 10px;
                        "
                      >
                        +66
                      </div>
                      <div class="font-16" style="color: #717579">
                        {{ selectedEvent.coordinator_phone || "-" }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      สถานที่จัดกิจกรรม
                    </div>
                    <div class="font-16" style="color: #717579">
                      {{ selectedEvent.location || "-" }}
                    </div>
                  </div>
                  <div>
                    <div class="font-14 mb-1" style="color: #d3d3d3">
                      รายละเอียด
                    </div>
                    <div class="font-16" style="color: #717579">
                      {{
                        selectedEvent.description ||
                        selectedEvent.details ||
                        "-"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div
              class="d-flex pa-4"
              style="background-color: #fff; flex-shrink: 0"
            >
              <Button theme="2" @onClick="dialog = false">ยกเลิก</Button>
            </div>
          </v-card>
        </v-dialog>
      </v-container>
    </divcard>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import Button from "@/components/input/Button";
import TextArea from "@/components/input/TextArea";
import { Icon } from "@iconify/vue2";
import { format, addMonths } from "date-fns"; // ใช้ date-fns สำหรับจัดการวันที่

export default {
  name: "CalendarActivity",
  components: {
    Icon,
    Button,
    TextField,
    TextArea,
  },
  data() {
    return {
      keyword: "",
      selectedDate: new Date().toISOString().substring(0, 10), // วันที่ที่เลือกในปฏิทิน
      dialog: false, // เปิด/ปิด Modal
      selectedEvent: {}, // ข้อมูลกิจกรรมที่เลือก
      events: [],
      searchMonth: "",
      searchYear: "",
      eventTypeConstant: [
        {
          text: "ภาคเหนือ",
          color: "#FFEFD5",
          textColor: "#AD9162",
          hoverColor: "#F3BA57",
          hoverTextColor: "#FFFFFF",
          borderColor: "#F5E9D3",
          quickActionBgColor: "#F6DFBF",
          quickActionColor: "#A58761",
        }, // สีเหลือง
        {
          text: "ภาคตะวันออกเฉียงเหนือ",
          color: "#FAECEB",
          textColor: "#D6635F",
          hoverColor: "#D6635F",
          hoverTextColor: "#fff",
          borderColor: "#F3DFE0",
          quickActionBgColor: "#F2D6D4",
          quickActionColor: "#CD5C58",
        }, // สีแดง
        {
          text: "ภาคตะวันออกเฉียงเหนือตอนล่าง",
          color: "#FDF0E8",
          textColor: "#EF6F36",
          hoverColor: "#EF6F36",
          hoverTextColor: "#F6DECF",
          borderColor: "#EDB39A",
          quickActionBgColor: "#F6DECF",
          quickActionColor: "#BE5628",
        }, // สีส้ม
        {
          text: "ภาคใต้",
          color: "#E6EDF0",
          textColor: "#4D5E80",
          hoverColor: "#204285",
          hoverTextColor: "#fff",
          borderColor: "#CAE0EA",
          quickActionBgColor: "#CFDEE4",
          quickActionColor: "#3F4F6F",
        }, // สีฟ้า
        {
          text: "สป.อว",
          color: "#E6EDF0",
          textColor: "#4D5E80",
          hoverColor: "#4D5E80",
          hoverTextColor: "#fff",
          borderColor: "#BDBDBD",
          quickActionBgColor: "#BDBDBD",
          quickActionColor: "#fff",
        }, // สีเทา
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    formatTitle() {
      return format(new Date(this.selectedDate), "MMMM, yyyy");
    },
    async getDataSearch() {
      this.getData(this.searchMonth, this.searchYear);
    },
    async getData(month = null, year = null) {
      // ดึงข้อมูลกิจกรรมจาก API
      if (month == null) {
        month = new Date().getMonth() + 1;
        this.searchMonth = month;
      }
      if (year == null) {
        year = new Date().getFullYear();
        this.searchYear = year;
      }
      let res = await this.$apiFire("CalendarActivity/index", {
        month: month,
        year: year,
        keyword: this.keyword,
      });
      if (res) {
        this.events = res.data;
      } else {
        this.events = [];
      }

      this.$nextTick(() => {
        if (this.selectedDate != new Date().toISOString().substring(0, 10)) {
          const elements = document.querySelectorAll(".v-present");
          elements.forEach((element) => {
            element.classList.add("v-present-inactive");
          });
        } else {
          const elements = document.querySelectorAll(".v-present");
          elements.forEach((element) => {
            element.classList.remove("v-present-inactive");
          });
        }
      });
    },
    createCalendarActivity() {
      this.$router.push({ name: "CalendarActivityCreate" });
    },
    _findEventType(event) {
      // สป: user_type อาจเป็น "สป.อว." (มีจุด) หรือ contains "สป" ให้ match entry "สป.อว"
      if (
        (event.user_type === "สป.อว." || event.user_type?.includes("สป")) &&
        !event.region
      ) {
        return this.eventTypeConstant.find((e) => e.text === "สป.อว") || null;
      }
      if (event.region) {
        const regionType = this.eventTypeConstant.find(
          (e) => e.text === event.region,
        );
        if (regionType) return regionType;
      }
      return this.eventTypeConstant.find((e) => e.text === event.user_type) || null;
    },
    // ฟังก์ชันสำหรับเลือกสีของกิจกรรม
    getEventColor(event) {
      const type = this._findEventType(event);
      return type ? type.color : event.color || "#FDECE7";
    },
    getEventTextColor(event) {
      const type = this._findEventType(event);
      return type ? type.textColor : event.textColor || "#F65F3C";
    },
    getEventBorderColor(event) {
      const type = this._findEventType(event);
      return type ? type.borderColor || type.color : event.borderColor || event.color || "#EDB39A";
    },
    getEventHoverColor(event) {
      const type = this._findEventType(event);
      return type ? type.hoverColor || type.color : event.hoverColor || event.color || "#F9CB00";
    },
    getEventHoverTextColor(event) {
      const type = this._findEventType(event);
      return type ? type.hoverTextColor || type.textColor : event.hoverTextColor || event.textColor || "#33170E";
    },
    getQuickActionBgColor(event) {
      const type = this._findEventType(event);
      return type ? type.quickActionBgColor || type.borderColor : event.quickActionBgColor || event.borderColor || "#EDB39A";
    },
    getQuickActionColor(event) {
      const type = this._findEventType(event);
      return type ? type.quickActionColor || type.textColor : event.quickActionColor || event.textColor || "#33170E";
    },
    getEventName(event) {
      return `${event.startTime || ""} ${event.name}`;
    },
    // แสดง Modal เมื่อคลิกกิจกรรม
    showEventDetails({ event }) {
      this.selectedEvent = event;
      this.dialog = true;
    },
    // เพิ่มคลาสสำหรับวันที่พิเศษ (วันที่ปัจจุบัน)
    getDayClass(day) {
      const today = new Date().toISOString().split("T")[0];
      return day.date === today ? "today" : "";
    },
    // ฟังก์ชันจัดการวันที่ให้อยู่ในรูปแบบที่อ่านง่าย
    formatDate(date) {
      if (!date) return "-";
      return format(new Date(date), "MMMM do, yyyy");
    },
    formatDateShort(date) {
      if (!date) return "-";
      return format(new Date(date), "dd/MM/yyyy");
    },
    //format time am/pm
    formatTime(time) {
      if (time == undefined) {
        return "-";
      } else {
        let [hours, minutes] = time.split(":").map(Number);

        // Validate hours and minutes
        if (
          isNaN(hours) ||
          isNaN(minutes) ||
          hours < 0 ||
          hours > 23 ||
          minutes < 0 ||
          minutes > 59
        ) {
          throw new Error(
            "Invalid time format. Hours should be 0-23 and minutes 0-59.",
          );
        }

        // Determine if it's AM or PM
        let period = hours >= 12 ? "PM" : "AM";

        // Convert hours to 12-hour format
        hours = hours % 12 || 12;

        // Pad minutes with leading zero if necessary
        minutes = minutes.toString().padStart(2, "0");

        // Return the formatted time
        return `${hours}:${minutes} ${period}`;
      }
    },
    editCalendarActivity() {
      this.$router.push({
        name: "CalendarActivityEdit",
        params: { id: this.selectedEvent.id },
      });
    },
    deleteCalendarActivity() {
      this.$apiFire("CalendarActivity/destroy", {
        id: this.selectedEvent.id,
      }).then((res) => {
        window.location.reload();
      });
    },
    onDelete() {
      let id = this.selectedEvent.id;
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("CalendarActivity/delete", id);
          if (res) {
            window.location.reload();
          }
        },
      });
    },
    quickEdit(event) {
      this.selectedEvent = event;
      this.editCalendarActivity();
    },
    quickDelete(event) {
      this.selectedEvent = event;
      this.onDelete();
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    async prev() {
      const select = addMonths(new Date(this.selectedDate), -1);

      this.selectedDate = select.toISOString().substring(0, 10);
      this.searchMonth = select.getMonth() + 1;
      this.searchYear = select.getFullYear();

      this.getData(this.searchMonth, this.searchYear);
    },
    next() {
      const select = addMonths(new Date(this.selectedDate), 1);

      this.selectedDate = select.toISOString().substring(0, 10);
      this.searchMonth = select.getMonth() + 1;
      this.searchYear = select.getFullYear();

      this.getData(this.searchMonth, this.searchYear);
    },
    canEditEvent(event) {
      const currentUser = this.$store.state.Auth.User;

      // ถ้าเป็น สป และ region เป็น null ก็สามารถแก้ไขได้เฉพาะ user_type ที่ตรงกัน
      if (
        (event.user_type === "สป.อว." || event.user_type?.includes("สป")) &&
        !event.region
      ) {
        return (
          currentUser.user_type === event.user_type ||
          currentUser.user_type?.includes("สป")
        );
      }

      // ถ้าเป็น RSP ต้อง user_type และ region ตรงกัน
      if (event.user_type === "RSP" && event.region) {
        return (
          currentUser.user_type === "RSP" && currentUser.region === event.region
        );
      }

      // สำหรับกรณีอื่นๆ ให้เช็ค user_type ที่ตรงกัน
      return currentUser.user_type === event.user_type;
    },
  },
};
</script>

<style>
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: #e0e0e0 1px solid;
  border-bottom: #e0e0e0 1px solid;
  color: #000000;
  min-height: 200px;
}
.v-calendar-weekly__day-label {
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: left;
  margin: 4px 0px 0px 8px;
}
.v-calendar-weekly__day-label .v-btn {
  font-size: 18px;
  text-transform: none;
}
.theme--light.v-calendar-weekly,
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  background-color: #fafafa;
}

.theme--light.v-calendar-weekly {
  border-top: #e0e0e0 1px solid;
  border-left: #e0e0e0 1px solid;
  border-right: #e0e0e0 1px solid;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border: #e0e0e0 1px solid;
}

.v-calendar-weekly__head-weekday,
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  padding: 18px;
  background-color: #fff;
}
.v-calendar-weekly__head {
  border-radius: 16px;
}
.v-application .pl-1 {
  height: 100%;
  display: flex;
  align-items: center;
}
.v-calendar-weekly__day > div {
  margin-bottom: 5px !important;
}
.v-event {
  left: 2.5%;
}
.v-calendar-weekly__head-weekday,
.theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday:not(:last-child) {
  border: 0;
}
.v-calendar-weekly__head-weekday {
  text-transform: capitalize;
}

.v-calendar-weekly__head-weekday.v-present,
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-present {
  background-color: var(--theme-color-seven);
  color: #fff;
  border-radius: 10px;
}
.v-calendar-weekly__head-weekday.v-present.v-present-inactive,
.theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday.v-present.v-present-inactive {
  background-color: #fff;
  color: #000;
}
.v-calendar-weekly__day.v-present .theme--light.v-btn.v-btn--has-bg {
  background-color: var(--theme-color-seven);
  color: #fff;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day .event {
  padding-left: 10px;
  font-size: 16px;
}
.v-calendar .v-event {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 6px;
}

.region-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.region-text {
  font-size: 14px;
  color: #333;
}

.event-card {
  transition: background-color 0.15s ease, color 0.15s ease;
}
.event-card:hover {
  background-color: var(--event-hover-color) !important;
  color: var(--event-hover-text-color) !important;
}

.event-name-text {
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-time-text {
  font-size: 11px;
  opacity: 0.85;
  white-space: nowrap;
  line-height: 1.3;
}

.event-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: white;
  position: relative;
  flex-shrink: 0;
}
</style>
